import { DATE_FORMAT_RFC } from 'common/constants'
import { convertAttachmentsSubmitPayload, convertPhotosSubmitPayload } from 'common/helpers'
import { Term } from 'common/models'
import moment from 'moment'

import { SUFFIX_TEMP_CLIENT_FIELD } from './validation'

export const convertSubmitPayload = ({ event_photos, event_attachments, impaired_at, ...rest }: any) => {
  return clearNullValues(
    removeTempFields({
      ...rest,
      impaired_at: moment(impaired_at).format(DATE_FORMAT_RFC),
      event_photos: convertPhotosSubmitPayload(event_photos),
      event_attachments: convertAttachmentsSubmitPayload(event_attachments),
    })
  )
}

const clearNullValues = (data: any) => {
  const newData = { ...data }
  Object.keys(newData).forEach(key => {
    if (newData[key] === null) {
      delete newData[key]
    }
  })
  return newData
}

const removeTempFields = (data: any) => {
  const newData = { ...data }
  Object.keys(newData).forEach(key => {
    if (key.endsWith(SUFFIX_TEMP_CLIENT_FIELD)) {
      delete newData[key]
    }
  })
  return newData
}

export function findPreviousTermMonth(date: string, terms: Term[]) {
  const termMonths =
    (terms || []).find(({ start_date, end_date }) => start_date <= date && date <= end_date)?.term_months || []

  const idx = termMonths.findIndex(({ start_date, end_date }) => {
    return start_date <= date && date <= end_date
  })

  return termMonths[idx - 1] || {}
}
